import React from 'react';

// mui
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

interface MessageSellerProps {
  isTopVisible: boolean;
  onClickMessageBrand: () => void;
  isMessageSellerDisabled?: boolean;
}

const MessageSeller = ({ isTopVisible, onClickMessageBrand, isMessageSellerDisabled = true }: MessageSellerProps) => {
  if (isMessageSellerDisabled) return null;
  if (isTopVisible) return null;
  return (
    <Box
      sx={{
        position: 'fixed',
        top: '50%',
        left: 0,
        transform: 'translateY(-50%)',
        zIndex: 1,
      }}
    >
      <Button
        variant="contained"
        sx={{
          borderTopRightRadius: 8,
          borderTopLeftRadius: 0,
          borderBottomRightRadius: 8,
          borderBottomLeftRadius: 0,
          padding: '20px 5px',
          backgroundColor: '#497262',
          minWidth: 'unset',
          height: 'max-content',
        }}
        onClick={onClickMessageBrand}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            writingMode: 'vertical-rl',
            textOrientation: 'mixed',
            transform: 'rotate(180deg)',
            gap: 1,
          }}
        >
          <MailOutlineIcon fontSize="small" sx={{ transform: 'rotate(90deg)' }} />
          <Box component="span" sx={{ fontSize: 12, fontWeight: 600, lineHeight: '24px' }}>
            Message Seller
          </Box>
        </Box>
      </Button>
    </Box>
  );
};

export default MessageSeller;
